export default __webpack_public_path__ + "static/media/logo.e0d43c82.svg";